export var PersonalTaxIdValidationFactory = (function() {
    /* Public Functions */

    var getValidationUtil = function(countryCode) {
        switch (countryCode) {
        case 'US': {
            return usValidator();
        }
        case 'CA': {
            return caValidator();
        }
        case 'ES': {
            return commonOneLengthValidator(9);
        }
        case 'FR': {
            return commonOneLengthValidator(15);
        }
        case 'SG': {
            return commonOneLengthValidator(9);
        }
        case 'PH': {
            return commonOneLengthValidator(9);
        }
        case 'MY': {
            return commonOneLengthValidator(12);
        }
        case 'HK': {
            return hkValidator();
        }
        case 'MO': {
            return moValidator();
        }
        case 'ID': {
            return commonOneLengthValidator(15);
        }
        case 'TH': {
            return commonOneLengthValidator(13);
        }
        case 'AR': {
            return commonOneLengthValidator(8);
        }
        case 'MX': {
            return commonOneLengthValidator(18);
        }
        case 'CL': {
            return commonOneLengthValidator(9);
        }
        case 'VN': {
            return commonTwoLengthsValidator(9, 12);
        }
        case 'BN': {
            return commonOneLengthValidator(8);
        }
        case 'ZA': {
            return commonOneLengthValidator(13);
        }
        case 'IT': {
            return commonOneLengthValidator(16);
        }
        case 'RU': {
            return commonOneLengthValidator(10);
        }
        case 'UA': {
            return commonOneLengthValidator(8);
        }
        case 'IL': {
            return commonOneLengthValidator(9);
        }
        default: {
            return defaultValidator();
        }
        }
    };

    var usValidator = function() {
        var isValidTaxId = function(ssn) {
            if (ssn && ssn.length === 9) {
                return true;
            } else {
                return false;
            }
        };
        return {
            isValidTaxId: isValidTaxId
        };
    };

    // http://www.straightlineinternational.com/docs/vaildating_canadian_sin.pdf
    // Valid sample number: 130 692 544
    var caValidator = function() {
        var isValidTaxId = function(sin) {
            if (sin && sin.length === 9) {
                var sinDigits = [];
                var checkNumber = [1, 2, 1, 2, 1, 2, 1, 2, 1];

                sin.trim();

                // Parse the input and break it up into digits
                for (var i = 0; i < sin.length; i++) {
                    var digits = parseInt(sin[i]);
                    if (!isNaN(digits)) {
                        sinDigits.push(digits);
                    }
                }

                // Traverse the digits and perform the self-checking computation
                var results = [];
                var sum = 0;
                if (sinDigits.length == 9) {
                    for (var i = 0; i < sinDigits.length; i++) {
                        var digit = sinDigits[i];
                        var checkdigit = checkNumber[i];

                        // Multiply the digit by the by the check digit in the same position
                        var product = digit * checkdigit;

                        // If the result has two digits, add those digits together
                        // The product will never be greater than 18
                        if (product >= 10) {
                            product = 1 + (product - 10);
                        }

                        // Add each product to a running sum
                        results.push(product);
                        sum += product;
                    }

                    // If the sum is evenly divisible by 10, it is a valid SIN
                    return sum % 10 === 0;
                }
            } else {
                return false;
            }
        };
        return {
            isValidTaxId: isValidTaxId
        };
    };

    var hkValidator = function() {
        var taxIdChecksum = function(id) {
            var checksumKey = {
                'A': 10,
                'B': 11,
                'C': 12,
                'D': 13,
                'E': 14,
                'F': 15,
                'G': 16,
                'H': 17,
                'I': 18,
                'J': 19,
                'K': 20,
                'L': 21,
                'M': 22,
                'N': 23,
                'O': 24,
                'P': 25,
                'Q': 26,
                'R': 27,
                'S': 28,
                'T': 29,
                'U': 30,
                'V': 31,
                'W': 32,
                'X': 33,
                'Y': 34,
                'Z': 35
            };
            var checksumNumber = [];
            checksumNumber.push(checksumKey[id.substr(0, 1)]);
            for (var i = 1; i < id.length - 1; i++) {
                if (id.length === 9 && i === 1) {
                    checksumNumber.push(checksumKey[id.substr(i, 1)]);
                } else {
                    checksumNumber.push(parseInt(id.substr(i, 1)));
                }
            }
            var calcChecksum = [];
            var checkTotal = 324;
            if (id.length === 9) {
                checkTotal = 0;
            }
            var multiplier = checksumNumber.length + 1;
            for (var x in checksumNumber) {
                calcChecksum.push(checksumNumber[x] * multiplier);
                multiplier--;
            }
            for (var x in calcChecksum) {
                checkTotal += calcChecksum[x];
            }
            var remaining = checkTotal % 11;
            var checkDigit;
            if (remaining === 1) {
                checkDigit = 'A';
            } else if (remaining === 0) {
                checkDigit = '0';
            } else {
                checkDigit = 11 - remaining;
            }
            if (checkDigit === parseInt(id.slice(-1))) {
                return true;
            } else {
                return false;
            }
        };
        var isValidTaxId = function(id) {
            var state;
            if (id && id.length === 9) {
                var check = id.substr(0, 2);
                if (isNaN(check)) {
                    state = taxIdChecksum(id);
                } else {
                    state = false;
                }
            } else if (id && id.length === 8) {
                var check = id.substr(0, 1);
                if (isNaN(check)) {
                    state = taxIdChecksum(id);
                } else {
                    state = false;
                }
            } else {
                state = false;
            }
            return state;
        };
        return {
            isValidTaxId: isValidTaxId
        };
    };

    var moValidator = function() {
        var isValidTaxId = function(id) {
            var state;
            if (id && id.length === 8) {
                var check = id.substr(0, 1);
                if (check === '1' || check === '5' || check === '7') {
                    state = true;
                } else {
                    state = false;
                }
            } else {
                state = false;
            }
            return state;
        };
        return {
            isValidTaxId: isValidTaxId
        };
    };

    var commonOneLengthValidator = function(length) {
        var isValidTaxId = function(taxId) {
            if (taxId && taxId.length === length) {
                return true;
            } else {
                return false;
            }
        };
        return {
            isValidTaxId: isValidTaxId
        };
    };

    var commonTwoLengthsValidator = function(lengthOne, lengthTwo) {
        var isValidTaxId = function(taxId) {
            if (taxId && taxId.length >= lengthOne && taxId.length <= lengthTwo) {
                return true;
            } else {
                return false;
            }
        };
        return {
            isValidTaxId: isValidTaxId
        };
    };

    var defaultValidator = function() {
        var isValidTaxId = function(taxId) {
            return true;
        };
        return {
            isValidTaxId: isValidTaxId
        };
    };

    return {
        getValidationUtil: getValidationUtil
    };
})
();



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/util/tax-id/personal-tax-id-validation.js
// module id = 340
// module chunks = 0